export const TAB_TYPES = {
    draft: 'draft',
    published: 'published',
}

export const ALL_PROJECTS_MEMBER = {
    id: null,
    isApprove: true,
    name: 'All projects',
    userId: null,
}

const TABS_TYPE_ARRAY = Object.keys(TAB_TYPES)

export const tryGetTabByQueryParam = queryParam => {
    const index = TABS_TYPE_ARRAY.indexOf(queryParam)
    if (index !== -1) return { tab: TABS_TYPE_ARRAY[index], isSuccess: true }

    return { tab: null, isSuccess: false }
}

export const PROJECT_STATUS = {
    published: 'PUBLISHED',
    draft: 'DRAFT',
}
